export default function FontStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Noto+Sans+Tamil:wght@400;500;600;700&family=Noto+Sans+Bengali:wght@400;500;600;700&display=swap');

      @keyframes tnpoll-confetti {
        0%   { transform: translate3d(0,0,0) rotate(0deg); opacity: 1; }
        70%  { opacity: 1; }
        100% { transform: translate3d(var(--drift, 0px), 110vh, 0) rotate(var(--rot, 720deg)); opacity: 0.85; }
      }
      @keyframes tnpoll-pulse {
        0%, 100% { transform: scale(1);   opacity: 1;    }
        50%      { transform: scale(1.6); opacity: 0.55; }
      }
      @keyframes tnpoll-pop {
        0%   { transform: scale(0);   }
        60%  { transform: scale(1.2); }
        100% { transform: scale(1);   }
      }
      @keyframes tnpoll-fadeup {
        0%   { opacity: 0; transform: translateY(14px); }
        100% { opacity: 1; transform: translateY(0);    }
      }

      select:focus, button:focus { outline: none; }
      select option { color: #fff; background: #15142A; }
      ::selection   { background: #00E5FF55; color: #fff; }

      ::-webkit-scrollbar       { width: 10px; height: 10px; }
      ::-webkit-scrollbar-track { background: rgba(255,255,255,0.02); }
      ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.12); border-radius: 4px; }
      ::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.2); }
    `}</style>
  );
}
